import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const VaporChip = props => {
  const { active, onClick, title, style } = props;
  return (
    <div
      onClick={onClick}
      style={style}
      className={
        "vapor-chip" + (active ? " active" : "")
      }
    >
      {title}
    </div>
  );
};

VaporChip.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  title:  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  style: PropTypes.object
};

VaporChip.defaultProps = {
  active: false,
  onClick: () => {},
  title: "",
  style: {}
};

export default VaporChip;
